
var menu =  [
  {
    icon: "PieChart",
    index: "/dashboard",
    title:"Dashboard",
    permission:"siteInfo",
  },
  {
    icon: "MapLocation",
    index: "/map",
    title:"Map",
    permission:"siteInfo",
  },
  {
    icon: "Money",
    index: "/revenue",
    title:"Revenue",
    permission:"energyRevenueInfo",
  },
  {
    icon: "Tickets",
    index: "6",
    title:"Activity",
    permission: "",
    subs: [
      {
        icon: "Document",
        index: "/bill",
        title: "Charging Sessions",
        active: 2,
        permission:"chargeBillInfo",
      },
      {
        icon: "Document",
        index: "/energyTransfer",
        title: "Energy Transfer",
        active: 2,
        permission:"siteInfo",
      },
    ]
  },
  {
    icon: "Bell",
    index: "/alerts",
    title:"Alerts",
    permission:"siteInfo",
  },
  {
    icon: "User",
    index: "8",
    title:"Users",
    permission:"userGroupInfo",
    subs: [
      {
        icon: "Document",
        index: "/fleets",
        title: "Fleets",
        active: 2,
        permission:"userGroupInfo",
      },
      {
        icon: "Document",
        index: "/chargingCards?type=U3",
        title: "Charging Cards",
        active: 2,
        permission:"nfcgroupInfo",
      },
    ],
  },
  {
    icon: "Setting",
    index: "9",
    title:"Configuration",
    active: 2,
    permission:"biInfo",
    subs: [
      {
        icon: "Memo",
        index: "/pricing",
        title:"Pricing",
        permission:"siteInfo",
      },
      {
        icon: "Document",
        index: "/stations",
        title: "Stations",
        permission:"siteInfo",
      },
      {
        icon: "Document",
        index: "/chargers",
        title: "Chargers",
        permission:"deviceInfo",
      },
      {
        icon: "Document",
        index: "/energy",
        title: "Energy Microgrid",
        permission:"siteInfo",
      },
      {
        icon: "Document",
        index: "/account",
        title: "Account",
        permission:"employeeInfo",
      },
      {
        icon: "Document",
        index: "/cpoInfo",
        title: "CPO info",
        permission:"dealerInfo",
      }
    ],
  }
];
// 操作权限判断
// var optMenu;
// var optMenu = menu.filter(item => {
//   return item.permission === 'biInfo'
// })  
// console.log(optMenu,'dsvfdbg')


export default menu